function MetricsHub() {
  return (
    <div className="container">
      <p>Metrics Hub</p>
    </div>
  );
}

export default MetricsHub;
